const Spinny = (props: { text?: string }) => {
  return (
    <>
      <div className="fixed inset-0 bg-dark-gray bg-opacity-50 transition-opacity"></div>
      <div className="fixed flex items-center justify-center h-screen w-screen z-5 transition-opacity">
        <img
          alt="spinny"
          src={"./images/rev_loading_small.gif"}
        ></img><div className="ml-4">{props.text}</div>
      </div>
    </>
  );
};

const PartialSpinny = (props) => {
  return (
    <>
      <div className="absolute inset-0 bg-dark-gray bg-opacity-50 transition-opacity h-full w-full" style={{ zIndex: props.z || 10500 }}>
        <div className="flex items-center justify-center h-full w-full z-5 transition-opacity">
          <img
            alt="spinny"
            src={"./images/rev_loading_small.gif"}
          ></img>
        </div>
      </div>
    </>
  );
};

const SimpleSpinny = () => {
  return (
    <>
      <div className="flex items-center justify-center h-full w-full z-5 transition-opacity">
        <img
          alt="spinny"
          src={"./images/rev_loading_small.gif"}
        ></img>
      </div>
    </>
  );
};

export { Spinny, PartialSpinny, SimpleSpinny };

